import Vue from 'vue'
import qs from 'query-string'

const STORAGE_PROP = 'queryString'

const { sessionStorage, location } = window

const storedString = JSON.parse(sessionStorage.getItem(STORAGE_PROP) || '{}')

const queryString = {
	...storedString,
	...qs.parse(location.search)
}

sessionStorage.setItem(STORAGE_PROP, JSON.stringify(queryString))

Vue.use({

	install (Vue) {
		Vue.prototype.$queryString = queryString
	}

})

export default queryString



// WEBPACK FOOTER //
// ./src/initializers/stored-query.js